import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const bank = {
  namespaced: true,

  state: () => ({
    loading: false,
    bankRegistrationSuccess: false,
    bankRegistrationFailure: false,
    bankList: [],
    validatedAccountData: {},
    accountBalance: null
  }),

  getters: {
    _loading: state => state.loading,
    _bankRegistrationSuccess: state => state.bankRegistrationSuccess,
    _bankRegistrationFailure: state => state.bankRegistrationFailure,
    _bankList: state => state.bankList,
    _validatedAccountData: state => state.validatedAccountData,
    _accountBalance: state => state.accountBalance
  },

  mutations: {
    LOADING (state, value) {
      state.loading = value
    },
    BANK_REGISTRATION_SUCCESS (state, value) {
      state.bankRegistrationSuccess = value
    },
    BANK_REGISTRATION_FAILURE (state, value) {
      state.bankRegistrationFailure = value
    },
    BANK_LIST (state, data) {
      state.bankList = data
    },
    VALIDATED_ACCOUNT_DATA (state, data) {
      state.validatedAccountData = data
    },
    ACCOUNT_BALANCE (state, data) {
      state.accountBalance = data
    }
  },

  actions: {
    CreateBank ({ commit, rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api.post('/Bank/CreateBank', payload, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            commit('LOADING', false)
            commit('BANK_REGISTRATION_SUCCESS', true)
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              commit('LOADING', false)
              commit('BANK_REGISTRATION_FAILURE', true)
              reject(error)
            }
          })
      })
    },
    UpdateBank ({ commit, rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api.post('/Bank/UpdateBank', payload, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            commit('LOADING', false)
            commit('BANK_REGISTRATION_SUCCESS', true)
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              commit('LOADING', false)
              commit('BANK_REGISTRATION_FAILURE', true)
              reject(error)
            }
          })
      })
    },
    GetByIdBank ({ commit, rootState, dispatch }, BankId) {
      return new Promise((resolve, reject) => {
        commit('LOADING', true)
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api.get(`/Bank/GetByIdBank?BankId=${BankId}`, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetByCodeBank ({ commit, rootState, dispatch }, BakCode) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        commit('LOADING', true)
        api.get(`/Bank/GetByCodeBank?BakCode=${BakCode}`, { headers })
          .then(response => response)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetAllBanks ({ rootState, commit, dispatch }) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        return api.get('/Bank/GetAllBanks', { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            const sortedBankList = response?.data?.sort((a, b) => a.bankName.localeCompare(b.bankName))

            commit('BANK_LIST', sortedBankList)
            // ------------------------------
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    // -----account number verification -----------------------
    GetAccountDetails ({ commit, rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }

        api.post('/AVS/NameEnquiry', payload, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            if ([0, '0', '00'].includes(response?.responseCode)) {
              const accountNumber = response.data.accountNumber
              const accountName = response.data.accountName.toLowerCase().replace(',', '')

              commit('VALIDATED_ACCOUNT_DATA', { accountNumber, accountName })
            } else {
              commit('VALIDATED_ACCOUNT_DATA', {})
            }
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              commit('VALIDATED_ACCOUNT_DATA', {})
              reject(error)
            }
          })
      })
    },
    // -----account balance -----------------------
    GetAccountBalance ({ commit, rootState, dispatch }, payload) {
      // rootState.loading = true

      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api.post(`/AVS/BalanceEnquiry?MerchantBillingAccountId=${payload?.merchantBillingAccountId}`, null, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => resolve(response))
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              // rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default bank
